import React from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { Form } from '../../../components/form/Form';
import SubmitButton from '../../../components/form/SubmitButton';
import { routes } from '../routes';

const SessionExpired: React.FC<React.PropsWithChildren<unknown>> = () => {
  const { t } = useTranslation();
  const history = useHistory();

  const handleRelogin = () => {
    // Session Expire happens after the refresh token expiration, so we need to redirect to login page with jwt query param
    history.push(routes.login.route.withQueryParams({ jwt: '1' }).create({}));
  };

  return (
    <>
      <h1 className="display-4 text-center mb-3">
        {t('sessionExpired.title')}
      </h1>
      <p className="text-muted text-center mb-5">
        {t('sessionExpired.message')}
      </p>
      <Form onSubmit={handleRelogin}>
        <SubmitButton block>{t('sessionExpired.reloginButton')}</SubmitButton>
      </Form>
    </>
  );
};

export default SessionExpired;
